<template>
    <Layout>
        <div slot="main" class="home-bg">
            <nav class="back-nav">
                <div class="strong">{{customType}}</div>
                <div class="back-icon" @click="goBack">
                    <img :src="back" alt="">
                </div>
            </nav>
            <div class="content-block">
                <h4 class="content-title">{{customTitle}}</h4>
                <h6 class="content-sub-title">{{lang.pubAt}} : {{customTime}}</h6>
                <div class="content custom-content editor-gen" v-html="customContent"></div>
            </div>
        </div>
    </layout>
</template>

<script>
import backSrc from '@/style/image/back.png';
import getLang from '@/utils/main/lang';
import Layout from '@/views/Layout.vue';
import ajax from '@/utils/ajax';
import gDate from '@/utils/format/gDate';
import router from '@/router';

export default {
    name: 'home',
    components: {
        Layout,
    },
    data() {
        return {
            isCn: window.localStorage.getItem('show-lang') !== 'en',
            back: backSrc,
            lang: getLang(),
            customType: '',
            customTitle: '',
            customTime: '',
            customContent: '',
        };
    },
    mounted() {
        const { id } = this.$route.params;
        ajax.get('/web/news/news_detail.json', {
            newsId: id,
        }).then((result) => {
            this.customType = this.isCn ? result.data.newsTypeCnName : result.data.newsTypeEnName;
            this.customTitle = this.isCn ? result.data.titleChina : result.data.titleEng;
            this.customContent = this.isCn ? result.data.contentChina : result.data.contentEng;
            this.customTime = gDate.datetimeFormat(result.data.pubTime, 'YYYY-MM-DD');
        }).catch(() => {});
    },
    methods: {
        goBack() {
            router.go(-1);
        },
    },
};
</script>
<style lang="less" scoped>
    .home-bg {
        background: #F1F1F1;
        padding-top: 44px;
    }
    .back-nav {
        width: 100%;
        height: 44px;
        background: #fff;
        display: flex;
        justify-content: space-between;
        align-content: center;
        position: fixed;
        top: 50px;
        left: 0;
        z-index: 3;
        border-bottom: 1px solid #F1F1F1;
        .back-icon {
            width: 11px;
            height: 17px;
            margin-top: 14px;
            margin-left: 20px;
            z-index: 3;
            img {
                width: 100%;
                height: 100%;
            }
        }
        .strong {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            font-size: 15px;
            color: #4A4A4A;
            text-align: center;
            line-height: 44px;
            font-weight: 500;
            overflow: hidden;
            padding: 0 50px;
            text-overflow: ellipsis;
            white-space: nowrap;
        }
    }
    .content-title {
        text-align: center;
        font-size: 14px;
        font-weight: 600;
        padding: 0 68px 12px;
        word-break: break-word;
    }
    .content-sub-title {
        text-align: center;
        font-size: 13px;
        padding: 0 68px 12px;
    }
    .content-block {
        background: #fff;
        padding: 15px 0;
    }
</style>
